import React from "react";
import { LaneTitle } from "react-trello/dist/styles/Base";
import "./styles.scss";

export const LaneBoard = (props) => {
  const {id, title, label} = props
  return (
    <div className="lane-kanban" key={id}>
      <LaneTitle>{`${title} (${label})`}</LaneTitle>
    </div>
  )
}
